export default __webpack_public_path__ + "static/media/primaryBallLoader.3b36a379.gif";